import { IFeatureFlag } from '@oliasoft/feature-flags';
import { HOST_BASE_URL } from 'client/urls/urls';

interface IClientConfig {
  owaApiUrl: string;
  idpServerUrl: string;
  dashboardUrl: string;
  hostBaseUrl: string;
  enableSentry: boolean;
  sentryEnvironment: string
  applicationId: string;
  customerAdminBaseUrl: string;
  featureFlags: {
    enableAllFlags: boolean;
    activeFlags: IFeatureFlag[];
    disabledFlags: string[];
  };
  pkce: {
    provider: 'oidc-client-ts' | 'axa-fr';
    renewTokenMode: 'refresh-token' | 'silent-renew';
  };
}

export default class ClientConfig {
  public static get config(): IClientConfig {
    const runtimeConfig = window.__runtimeConfigStatic;
    const owaApiUrl = runtimeConfig?.api_base_url;
    const idpBaseUrl = runtimeConfig?.authentication_server_base_url;
    const clientId = runtimeConfig?.client_id;
    const enableSentry = runtimeConfig?.enable_sentry;
    const sentryEnvironment = runtimeConfig?.sentry_environment;
    const dashboardUrl = runtimeConfig?.dashboard_url;
    const enableAllFlags = runtimeConfig?.feature_flags?.enable_all_flags;
    const activeFlags = runtimeConfig?.feature_flags?.active_flags;
    const disabledFlags = runtimeConfig?.feature_flags?.disabled_flags;
    const provider = runtimeConfig?.pkce?.provider;
    const renewTokenMode = runtimeConfig?.pkce?.renew_token_mode;

    return {
      owaApiUrl,
      idpServerUrl: idpBaseUrl,
      dashboardUrl,
      hostBaseUrl: HOST_BASE_URL,
      applicationId: clientId,
      enableSentry,
      sentryEnvironment,
      customerAdminBaseUrl: runtimeConfig?.customer_admin_base_url,
      featureFlags: {
        enableAllFlags,
        activeFlags,
        disabledFlags,
      },
      pkce: {
        provider,
        renewTokenMode,
      },
    };
  }
}
